import type { Action } from '../App/types';
import {
  HANDLE_HUD_RECALC_SUCCESS,
  HANDLE_HUD_RECALC_FAILURE,
} from './constants';

export function handleHudRecalcSuccess({
  payload,
  title,
  message,
}: Object): Action<any> {
  return {
    type: HANDLE_HUD_RECALC_SUCCESS,
    payload: { ...payload, title, message },
  };
}

export function handleHudRecalcFailure({
  payload,
  title,
  message,
}: Object): Action<any> {
  return {
    type: HANDLE_HUD_RECALC_FAILURE,
    payload: { ...payload, title, message },
  };
}
